

import { ProductsMix } from "@/UI/mixins/Store/ProductsMix"
import { ProductsStore } from "@/store/modules/Warehouse/Products"
import { ProductsTableMix } from "@/UI/mixins/Store/ProductsTableMix"
import { ProductsCategoriesMix } from "@/UI/mixins/Store/ProductsCategoriesMix"
import { ProductsCategoriesTableMix } from "@/UI/mixins/Store/ProductsCategoriesTableMix"
import { Component } from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import AppSimpleLink from '@/UI/components/Link/AppSimpleLink.vue';
import { mixins } from 'vue-class-component';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import { ProxyDataForm } from "@/UI/components/Helpers/ProxyDataForm"

@Component({
    components: { PageTitle, AppSimpleLink, BaseDataForm }
})
export default class Archive extends mixins( ProductsCategoriesTableMix, ProductsCategoriesMix,  ProductsMix, ProductsTableMix, ProxyDataForm )
{
    async created(): Promise<void> {
        this.tableLoad = false
        try {
            await ProductsStore.fetchAll({limit:this.AppPageParams.pageSize, filter:{archived:true}})
        } catch (e) {
            console.log('Parse Data load error')
        }

        this.formReady = true
        this.tableLoad = true
    }
}
